export const init = () => {
  if (!['list', 'internal_search'].includes(tc_vars.env_template)) return;

  /* ENHANCED E-COMMERCE - IMPRESSION - PAGELIST */
  /* SPOTLIGHT */

  const fwk = CUBE.Analytics;

  const classSpotlightViewed = 'viewed';

  /**
   * SET SPOTLIGHT AS VIEWED
   * 	- If element is visible, and $selectedSpotlight hasn't been seen yet
   */
  const setSpotlightAsViewed = sendImpression => {
    const $spotlight = fwk.utils.pagelist.getSpotlight();
    const $productSelected = fwk.utils.pagelist.getSelectedProduct($spotlight);

    if (!$productSelected.hasClass(classSpotlightViewed)) {
      const model = fwk.utils.pagelist.getModel($productSelected);
      if (model) {
        if (sendImpression) fwk.enhanced.sendImpression(model);

        $productSelected.addClass(classSpotlightViewed);
      }
    }
  };

  $(document).on('ready', () => {
    // IMPRESSION on INIT (1st spotlight -- timeout to delay after carousel render)
    setTimeout(() => {
      setSpotlightAsViewed(false);
    }, 1);

    // IMPRESSION on SPOTLIGHT CHANGE (& COLORAMA)
    $('#lpt-tg').on('afterChange.ec', () => {
      setSpotlightAsViewed(true);
    });
  });
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-1-impression-spotlight.js